import { FC, useEffect, useState } from 'react'

import { ActivityType } from '@forto-dev/feed-v2-models'

import { ActivityFeedItemChangeTimestamp } from './ActivityFeedItemChangeTimestamp'
import { ActivityFeedItemCreateShipment } from './ActivityFeedItemCreateShipment'
import { ActivityFeedItemDeviationInsight } from './ActivityFeedItemDeviationInsight'
import { ActivityFeedItemDeviationRiskInsight } from './ActivityFeedItemDeviationRiskInsight'
import { ActivityFeedItemDocumentUpload } from './ActivityFeedItemDocumentUpload'
import { ActivityFeedItemGenericAction } from './ActivityFeedItemGenericAction'
import { ActivityFeedItemMessage } from './ActivityFeedItemMessage'
import { ActivityFeedItemReassuranceInsight } from './ActivityFeedItemReassuranceInsight'
import { ActivityFeedItemShipmentUpdate } from './ActivityFeedItemShipmentUpdate'
import { ActivityFeedItemSubscriptionAdded } from './ActivityFeedItemSubscriptionAdded'
import { ActivityFeedItemSubscriptionRemoved } from './ActivityFeedItemSubscriptionRemoved'
import { ActivityFeedItemUpdateInsight } from './ActivityFeedItemUpdateInsight'
import { ActivityFeedItemProps } from './types'

const MS_PER_SECOND = 1000

export const ActivityFeedItem: FC<ActivityFeedItemProps> = ({ item, status, v2Flow }) => {
  const [unreadStatus, setUnreadStatus] = useState<string | undefined>(status)

  useEffect(() => {
    let newLabelTimeout: number
    if (unreadStatus) {
      newLabelTimeout = window.setTimeout(() => setUnreadStatus(undefined), 5 * MS_PER_SECOND)
    }
    return () => {
      window.clearTimeout(newLabelTimeout)
    }
  }, [unreadStatus, setUnreadStatus])

  const itemProps = { item, status: unreadStatus, v2Flow }

  switch (item.activity.type) {
    case ActivityType.MessageFeedV1:
      return <ActivityFeedItemMessage {...itemProps} />
    case ActivityType.ChangeCargoReadyDate:
    case ActivityType.ChangeCargoReadyDateAggregation:
    case ActivityType.ChangePickup:
    case ActivityType.ChangePickupAggregation:
    case ActivityType.ChangeEstimatedTimeDeparture:
    case ActivityType.ChangeEstimatedTimeDepartureAggregation:
    case ActivityType.ChangeArrival:
    case ActivityType.ChangeArrivalAggregation:
    case ActivityType.ChangeDelivery:
    case ActivityType.ChangeDeliveryAggregation:
      return <ActivityFeedItemChangeTimestamp {...itemProps} />
    case ActivityType.DocumentUploadFeedV1:
      return <ActivityFeedItemDocumentUpload {...itemProps} />
    case ActivityType.SubscriptionAddFeedV1:
      return <ActivityFeedItemSubscriptionAdded {...itemProps} />
    case ActivityType.SubscriptionRemoveFeedV1:
      return <ActivityFeedItemSubscriptionRemoved {...itemProps} />
    case ActivityType.CreateShipment:
      return <ActivityFeedItemCreateShipment {...itemProps} />
    case ActivityType.ShipmentUpdateFeedV1:
    case ActivityType.UpdateShipment:
      return <ActivityFeedItemShipmentUpdate {...itemProps} />
    case ActivityType.DeviationInsight:
      return <ActivityFeedItemDeviationInsight {...itemProps} />
    case ActivityType.DeviationRiskInsight:
      return <ActivityFeedItemDeviationRiskInsight {...itemProps} />
    case ActivityType.ReassuranceInsight:
      return <ActivityFeedItemReassuranceInsight {...itemProps} />
    case ActivityType.UpdateInsight:
      return <ActivityFeedItemUpdateInsight {...itemProps} />
    default:
      return <ActivityFeedItemGenericAction {...itemProps} />
  }
}
